import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

const languages = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'fr', label: 'FR', name: 'Français' },
  { code: 'de', label: 'DE', name: 'Deutsch' },
  { code: 'ar', label: 'عر', name: 'العربية' },
];

export const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-0.5 sm:gap-1 bg-slate-100 rounded-full p-0.5 sm:p-1" data-testid="language-switcher">
      <Globe className="w-3 h-3 sm:w-4 sm:h-4 text-slate-500 mx-1 sm:mx-2 hidden sm:block" />
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => setLanguage(lang.code)}
          data-testid={`lang-btn-${lang.code}`}
          className={`px-2 sm:px-3 py-1 sm:py-1.5 text-xs sm:text-sm font-medium rounded-full transition-colors duration-200 ${
            language === lang.code
              ? 'bg-brand text-white'
              : 'text-slate-600 hover:bg-slate-200'
          }`}
          title={lang.name}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};
